/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planpricesnet2Inputs */

const en_planpricesnet2 = /** @type {(inputs: Planpricesnet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All prices plus VAT.`)
};

const de_planpricesnet2 = /** @type {(inputs: Planpricesnet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Preise zzgl. USt.`)
};

/**
* | output |
* | --- |
* | "All prices plus VAT." |
*
* @param {Planpricesnet2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planpricesnet2 = /** @type {((inputs?: Planpricesnet2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planpricesnet2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planpricesnet2(inputs)
	return de_planpricesnet2(inputs)
});
export { planpricesnet2 as "planPricesNet" }